import React from 'react';
export function MethodSection() {
  return <section className="bg-[#2a1f14] text-white py-24 px-4 relative overflow-hidden" data-id="element-93">
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#c9a96e]/10 rounded-full blur-3xl" data-id="element-94"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#b5634b]/10 rounded-full blur-3xl" data-id="element-95"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-96">
        <p className="font-opensans text-xl md:text-2xl text-gray-300 mb-10 leading-relaxed" data-id="element-97">
          Las enseñanzas contemplativas llevan siglos ayudando a las personas a
          entender su mente.
        </p>

        <div className="bg-[#3d2e20] p-8 md:p-10 rounded-xl border-l-4 border-[#c9a96e] mb-12 shadow-2xl" data-id="element-98">
          <p className="font-oswald text-3xl md:text-4xl font-bold mb-4 text-white uppercase" data-id="element-99">
            No se trata de eliminar los pensamientos.
          </p>
          <p className="font-oswald text-3xl md:text-4xl font-bold text-[#c9a96e] uppercase" data-id="element-100">
            Se trata de aprender a no quedar atrapado en ellos.
          </p>
        </div>

        <p className="font-opensans text-2xl md:text-3xl text-gray-200 mb-8" data-id="element-101">
          Cuando entiendes cómo funciona tu mente:
        </p>

        <div className="space-y-6" data-id="element-102">
          <p className="font-oswald text-4xl md:text-5xl font-bold text-white uppercase tracking-wide" data-id="element-103">
            
          </p>
          <p className="font-oswald text-4xl md:text-5xl font-bold text-white uppercase tracking-wide" data-id="element-104">
            Y empiezas a vivir con más claridad.
          </p>
        </div>
      </div>
    </section>;
}